'use client';

import { useLocale } from './LocaleProvider';
import { dict, t } from '@/lib/i18n';
import { SophiaLogo } from './SophiaLogo';

export function CTA() {
  const { locale } = useLocale();

  return (
    <section id="cta" className="relative py-14 md:py-28">
      <div className="mx-auto max-w-5xl px-6">
        <div className="relative overflow-hidden rounded-[32px] bg-cta-gradient p-10 sm:p-16 text-center shadow-glow">
          {/* Ambient glow */}
          <div
            aria-hidden
            className="absolute -top-24 left-1/2 -translate-x-1/2 w-[30rem] h-[30rem] rounded-full bg-white/10 blur-3xl"
          />
          <div className="relative">
            <h2 className="font-serif text-4xl sm:text-5xl text-white leading-tight mb-8 max-w-2xl mx-auto">
              {t(dict.cta.heading, locale)}
            </h2>
            <a
              href="https://chrome.google.com/webstore/detail/bcemapjfjdkcfffmmimnaoknicppgapg"
              className="press-lift group inline-flex items-center gap-2 px-8 py-4 rounded-pill bg-white text-ink-900 font-semibold text-lg shadow-xl transition-[transform,box-shadow] duration-200 ease-out hover:shadow-2xl"
            >
              <SophiaLogo variant="badge" size={22} />
              {t(dict.cta.button, locale)}
              <span aria-hidden className="arrow-slide opacity-80">→</span>
            </a>
            <p className="mt-6 text-sm text-white/70">
              Chrome · Brave · Arc · Edge — any Chromium browser
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
